import React from "react";
import ReactDOM from "react-dom";
import SignupForm from "signupform/index";

let toolcontainer = document.getElementById("lndb-signupform");
if (toolcontainer) {
	const event_id = parseInt(toolcontainer.getAttribute("data-eventid"));
	const is_preview = toolcontainer.getAttribute("data-mode") === "preview";
	const language = toolcontainer.getAttribute("data-language") === "en" ? "en" : "de";

	if (event_id) {
		ReactDOM.render(<SignupForm event_id={event_id} is_preview={is_preview} language={language}/>, toolcontainer);
	} else {
		ReactDOM.render(
			<p>Bitte gib die ID der Veranstaltung an.</p>,
			toolcontainer
		);
	}
}
